import { render, staticRenderFns } from "./PortfolioTwo.vue?vue&type=template&id=98e835c8"
import script from "./PortfolioTwo.vue?vue&type=script&lang=js"
export * from "./PortfolioTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports